import React, { PureComponent } from "react";
import { PieChart, Pie, Sector, Cell, ResponsiveContainer, Tooltip, Legend } from "recharts";

import numeral from "numeral";

import { colors } from "containers/Next/NextReducer";

import styles from "./style.module.css";

export default class FieldTypesPieChart extends PureComponent {
  render() {
    const { data } = this.props;

    const binaryCount = data.binary_col_count;
    const numericCount = data.numeric_col_count;
    const categoricalCount = data.text_col_count;
    const emptyCount = data.empty_col_count;
    const dateCount = data.date_col_count;

    const totalCount = binaryCount + numericCount + categoricalCount + emptyCount + dateCount;

    const retData = [
      {
        name: "BINARY (" + ((binaryCount / totalCount) * 100).toFixed(2) + "%)",
        Count: binaryCount,
        color: "#0B4BDE"
      },
      {
        name: "NUMERIC (" + ((numericCount / totalCount) * 100).toFixed(2) + "%)",
        Count: numericCount,
        color: "#60A5FA"
      },
      {
        name: "CATEGORICAL (" + ((categoricalCount / totalCount) * 100).toFixed(2) + "%)",
        Count: categoricalCount,
        color: "#75C5FF"
      },
      {
        name: "DATE (" + ((dateCount / totalCount) * 100).toFixed(2) + "%)",
        Count: dateCount,
        color: "#C1E5FE"
      },
      {
        name: "EMPTY (" + ((emptyCount / totalCount) * 100).toFixed(2) + "%)",
        Count: emptyCount,
        color: "#EFECF6"
      }
    ];

    return (
      <div className={styles.overviewPieChart}>
        <div className={styles.overviewPieHolder}>
          {/*
          <div className={styles.typesMidValue}>
            <div className={styles.typesMidTop}>
              {numeral(binaryCount).format("0a")}
            </div>
            <div className={styles.typesMidBot}>{numeral(binaryCount / totalCount * 100).format("0.00a") + "%"}</div>
          </div>
          */}
          <PieChart width={150} height={150}>
            <Pie
              data={retData}
              cx={75}
              cy={75}
              innerRadius={40}
              outerRadius={50}
              fill="#8884d8"
              paddingAngle={2}
              dataKey="Count"
            >
              {retData.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={entry?.color} />
              ))}
            </Pie>
            <Tooltip />
          </PieChart>
        </div>
        <div className={styles.funnelPieLegend}>
          {retData.map((entry, index) => (
            <div className={styles.pieLegendItem} key={"pl_" + index}>
              <div className={styles.pieLegendIcon} style={{ background: entry?.color }} />
              <div className={styles.pieLegendText}>{entry.name}</div>
            </div>
          ))}
        </div>
      </div>
    );
  }
}
